import gql from 'graphql-tag'

export const SchoolListingFieldsFragment = gql`
  fragment SchoolListingFields on SchoolListing {
    schoolId
    externalSchoolId
    slug
    type
    name
    imageUrl
    programType
    location {
      latitude
      longitude
      state
      city
    }
    aggregateRatings {
      count
      overall
    }
  }
`
